
import React from 'react';
import { Button } from '@/components/ui/button';
import { WifiOff, RotateCcw } from 'lucide-react';

const OfflinePage: React.FC = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] p-4 text-center">
      <div className="bg-muted/30 w-16 h-16 rounded-full flex items-center justify-center mb-6">
        <WifiOff className="h-8 w-8 text-muted-foreground" />
      </div>
      
      <h1 className="text-2xl font-bold mb-2">You're offline</h1>
      <p className="text-muted-foreground mb-6 max-w-md">
        It seems you've lost your internet connection. Some features may be unavailable until connection is restored.
      </p>
      
      <div className="space-y-4">
        <Button 
          variant="outline" 
          onClick={handleRetry}
          className="flex items-center gap-2"
        >
          <RotateCcw className="h-4 w-4" />
          Try Again
        </Button>
        <p className="text-sm text-muted-foreground">
          Don't worry, your recent changes have been saved locally and will sync when you're back online.
        </p>
      </div>
    </div>
  );
};

export default OfflinePage;
